var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewIndicatorFilledSvgrepocom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.5C20.5228 5.5 25 9.97715 25 15.5C25 21.0228 20.5228 25.5 15 25.5C9.47715 25.5 5 21.0228 5 15.5C5 9.97715 9.47715 5.5 15 5.5ZM16.25 10.5H13.75V14.25H10V16.75L13.75 16.75V20.5H16.25L16.25 16.75L20 16.75V14.25H16.25L16.25 10.5Z",
    fill: "#1A9F0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIndicatorFilledSvgrepocom);
export default __webpack_public_path__ + "static/media/new-indicator-filled_svgrepo.com.c6dc6b48a0b418ec6168b948bd3c5f2c.svg";
export { ForwardRef as ReactComponent };